export default __webpack_public_path__ + "static/media/Novaa_Futurist_Still_3.9e34ce0d.jpg";